import { useState } from 'react'
import { useFormikContext } from 'formik'
import { useHistory } from 'react-router-dom'
import { orderBy } from 'lodash'

import Modal from 'components/Modal'
import MultiSelectFilter from 'components/MultiSelectFilter'
import ModifierLabel from 'components/Item/Form/Labels/ModifiersLabel'

import { FUSE_OPTIONS } from 'utils/fuseSettings'
import { MODIFIER_FILTER_OPTIONS } from 'resources'

const ModifiersDrawer = ({
  setFormStep,
  modifierGroups,
  isLoading,
}) => {
  const { values, setFieldValue } = useFormikContext()

  const [selectedItemsUuids, setSelectedItemsUuids] = useState(
    values?.modifierMinMax?.map((modifier) => modifier?.modifierUuid)
  )
  const [modifierMinMax, setModifierMinMax] = useState(
    values?.modifierMinMax
  )

  const history = useHistory()

  const alphabeticallySortedModifierGroups = orderBy(
    modifierGroups,
    'name'
  )

  const handleMinMaxChange = (event, modifierUuid) => {
    const { name, value } = event.target
    const modifier = modifierMinMax.find(
      (modifier) => modifier?.modifierUuid === modifierUuid
    )

    if (modifier) {
      const newModifierMinMax = modifierMinMax?.map((modifier) => {
        if (modifier?.modifierUuid === modifierUuid) {
          return { ...modifier, [name]: value }
        }
        return modifier
      })
      setModifierMinMax(newModifierMinMax)
    } else {
      setModifierMinMax([
        ...modifierMinMax,
        {
          modifierUuid,
          maximumCount: null,
          minimumCount: null,
          [name]: value,
        },
      ])
    }
  }

  const handleChangeCheckbox = (value) => {
    setSelectedItemsUuids(value)
  }

  const onCloseModal = () => {
    history.push({ state: { itemUuid: null } })
  }

  const onClickReturn = () => {
    setFormStep('itemsForm')
  }

  const handleSave = () => {
    // remove modifierMinMax that are not selected
    const removedModifierMinMax = modifierMinMax?.filter((modifier) =>
      selectedItemsUuids.includes(modifier?.modifierUuid)
    )

    // add default min max values to selected modifiers
    const chckedModifiersWithDefaultMinMax = selectedItemsUuids.map(
      (selectedUuid) => {
        const modifier = removedModifierMinMax.find(
          (modifier) => modifier?.modifierUuid === selectedUuid
        )

        // replace empty strings values with null
        let modifierWithoutEmptyStrings
        if (modifier) {
          modifierWithoutEmptyStrings = Object.fromEntries(
            Object.entries(modifier).map(([key, value]) => [
              key,
              value === '' ? null : value,
            ])
          )
        }

        // if modifier was not selected before, add default min max values
        return modifier
          ? modifierWithoutEmptyStrings
          : {
              modifierUuid: selectedUuid,
              maximumCount: null,
              minimumCount: null,
            }
      }
    )

    setFormStep('itemsForm')
    setFieldValue('modifierMinMax', chckedModifiersWithDefaultMinMax)
  }

  return (
    <Modal
      title="Modifier Groups"
      isReturnIcon
      onClose={onCloseModal}
      onClickReturn={onClickReturn}
      className="-narrow"
      isLoading={isLoading}
      onRequestClose={onCloseModal}
    >
      <MultiSelectFilter
        items={alphabeticallySortedModifierGroups}
        itemsUuids={selectedItemsUuids}
        handleSave={handleSave}
        handleChangeCheckbox={handleChangeCheckbox}
        label={(item) => (
          <ModifierLabel
            item={item}
            handleChangeCheckbox={handleChangeCheckbox}
            selectedItemsUuids={selectedItemsUuids}
            handleMinMaxChange={handleMinMaxChange}
            modifierMinMax={modifierMinMax}
          />
        )}
        fuseSettings={FUSE_OPTIONS}
        doubleToggleButtonOptions={MODIFIER_FILTER_OPTIONS}
        checkboxIndeterminateLabel="All Modifier Groups"
      />
    </Modal>
  )
}

export default ModifiersDrawer
